import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("As senhas não coincidem");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Senha redefinida com sucesso");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-3">
          <img src="/valbrac-logo.png" alt="Valbrac" className="h-11 w-11 rounded-xl bg-white p-1 shadow" />
          <div>
            <p className="text-lg font-extrabold text-[#0B2545]">VALBRAC</p>
            <p className="text-xs font-medium uppercase tracking-widest text-emerald-600">Portal SSMA</p>
          </div>
        </div>
        <h2 className="text-2xl font-bold text-[#0B2545]">Nova senha</h2>
        <p className="mt-1 text-sm text-slate-500">Defina sua nova senha de acesso</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label className="mb-1.5 block text-sm font-medium text-slate-700">Nova senha</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              required className="h-11 bg-white" data-testid="reset-password" />
          </div>
          <div>
            <Label className="mb-1.5 block text-sm font-medium text-slate-700">Confirmar senha</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              required className="h-11 bg-white" data-testid="reset-confirm" />
          </div>
          {error && <p className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-600">{error}</p>}
          <Button type="submit" disabled={loading || !token} className="h-11 w-full bg-[#0B2545] hover:bg-[#134074]" data-testid="reset-submit">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Redefinir senha"}
          </Button>
        </form>
        <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm text-[#134074] hover:underline">
          <ArrowLeft className="h-4 w-4" /> Voltar para o login
        </Link>
      </div>
    </div>
  );
}
